import React, { memo, useMemo } from 'react';
import { TestDetailQuizModel } from 'models/test-detail.model';
import DragDropComponent, { DragDropItem } from 'components/common/DragDropComponent';
import './index.css';

interface PropTypes {
  question: TestDetailQuizModel;
  showTruth: boolean;
  isPreview?: boolean;
}

const getRandomAnswer = (available: string[], exclude: string[]): string => {
  const filtered = available.filter(ans => !exclude.includes(ans));
  if (filtered.length === 0) return '';
  const randIndex = Math.floor(Math.random() * filtered.length);
  return filtered[randIndex];
};

const TCHPhuHopComponent: React.FC<PropTypes> = ({ question, isPreview, showTruth }) => {

  const { leftColumn, rightColumn } = useMemo(() => {
    const left: DragDropItem[] = [];
    const right: DragDropItem[] = [];
    const usedAnswers: string[] = [];
    const answerRights =
      question.testQuestionAnswers?.map((item) => item.answerRight || '') || [];

    (question.testQuestionAnswers || []).forEach((item, index) => {
      left.push({
        id: `${index}`,
        text: item?.answerLeft || '',
      });

      let rightText = '';
      if (Array.isArray(question.userAnswer) && question.userAnswer[index]) {
        rightText = question.userAnswer[index];
      } else {
        rightText = getRandomAnswer(answerRights, usedAnswers);
      }

      usedAnswers.push(rightText);

      right.push({
        id: `right-${index}`,
        text: rightText,
      });
    });

    // Bổ sung các đáp án chưa dùng vào rightColumn
    answerRights.forEach((ans, i) => {
      if (!usedAnswers.includes(ans)) {
        right.push({
          id: `right-${i}`,
          text: ans,
        });
      }
    });

    return { leftColumn: left, rightColumn: right };
  }, [question]);
  return (
    <div className="question-content">
      <DragDropComponent leftColumn={leftColumn} rightColumn={rightColumn}  question={question} canDrag={!isPreview} showTruth={showTruth} />
    </div>
  );
};

export default memo(TCHPhuHopComponent);
